import {createSlice} from '@reduxjs/toolkit';
import {NameBasicDto} from 'src/shared/common-dtos/name-basic-dto';
import {CasePricingDetailsDto} from 'src/shared/services/case-pricing/dto/case-pricing-details-dto';
import {CaseTreatmentDetailsDto} from 'src/shared/services/case-treatment/dto/case-treatment-details-dto';

interface CasePricingInitialState {
  casePricingDetails: CasePricingDetailsDto | undefined;
  caseTreatmentList: Array<CaseTreatmentDetailsDto> | undefined;
  isCaseTreatmentListLoading: boolean | undefined;
  caseTreatmentMaterialList: Array<NameBasicDto> | undefined;
  isCaseTreatmentMaterialListLoading: boolean | undefined;
}

const initialState: CasePricingInitialState = {
  casePricingDetails: undefined,
  caseTreatmentList: [],
  isCaseTreatmentListLoading: false,
  caseTreatmentMaterialList: [],
  isCaseTreatmentMaterialListLoading: false,
};

const casePricingSlice = createSlice({
  name: 'casePricing',
  initialState: initialState,
  reducers: {
    setCasePricingDetails: (state, action) => {
      state.casePricingDetails = action.payload;
    },
    setCaseTreatmentList: (state, action) => {
      state.caseTreatmentList = action.payload;
    },
    setIsCaseTreatmentListLoading: (state, action) => {
      state.isCaseTreatmentListLoading = action.payload;
    },
    setCaseTreatmentMaterialList: (state, action) => {
      state.caseTreatmentMaterialList = action.payload;
    },
    setIsCaseTreatmentMaterialListLoading: (state, action) => {
      state.isCaseTreatmentMaterialListLoading = action.payload;
    },
  },
});

export const {
  setCasePricingDetails,
  setCaseTreatmentList,
  setIsCaseTreatmentListLoading,
  setCaseTreatmentMaterialList,
  setIsCaseTreatmentMaterialListLoading,
} = casePricingSlice.actions;

export default casePricingSlice.reducer;
